export const routes = (prefix, pre) => [
    {
        name: `${prefix}.${pre}.received-payments-report.index`,
        path: `/${prefix}/${pre}/received-payments-report`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.received-payments-report.index`,
                PageDescription: "Accounts/Finance Reports: Received Payments report",
            },
        },
    }, 
    {
        name: `${prefix}.${pre}.push-received-payments-report.index`,
        path: `/${prefix}/${pre}/push-received-payments-report`,
        component: () => import('./CashPush.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.push-received-payments-report.index`,
                PageDescription: "Accounts/Finance Reports:Push Received Payments report",
            },
        },
    },{
        name: `${prefix}.${pre}.push-deposits-payments-report.index`,
        path: `/${prefix}/${pre}/push-deposits-payments-report`,
        component: () => import('./DepositPush.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.push-deposits-payments-report.index`,
                PageDescription: "Accounts/Finance Reports:Push Received Deposit Payments report",
            },
        },
    },{
        name: `${prefix}.${pre}.declared-received-payments-report.index`,
        path: `/${prefix}/${pre}/declared-received-payments-report`,
        component: () => import('./DeclaredCashPayments.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.declared-received-payments-report.index`,
                PageDescription: "Accounts/Finance Reports:Declared Received Payments report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.received-payments-report.print-cashout.index`,
        path: `/${prefix}/${pre}/received-payments-report/print-cashout`,
        component: () => import('./prints/ApprovedCashOut.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.received-payments-report.index`,
                PageDescription: "Accounts/Finance Reports: Received Payments report",
            },
            print: true,
        },
    },
    {
        name: `${prefix}.${pre}.received-payments-report.print-bill-payment.index`,
        path: `/${prefix}/${pre}/received-payments-report/print-bill-payment`,
        component: () => import('./prints/BillsReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.received-payments-report.index`,
                PageDescription: "Accounts/Finance Reports: Received Payments report",
            },
            print: true,
        },
    },
    {
        name: `${prefix}.${pre}.received-payments-report.print-deposits.index`,
        path: `/${prefix}/${pre}/received-payments-report/print-deposits`,
        component: () => import('./prints/DepositsReceived.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.received-payments-report.index`,
                PageDescription: "Accounts/Finance Reports: Received Payments report",
            },
            print: true,
        },
    },
    {
        name: `${prefix}.${pre}.received-payments-report.print`,
        path: `/${prefix}/${pre}/received-payments-report/print`,
        component: () => import('./prints/ReceivedPaymentReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.received-payments-report.index`,
                PageDescription: "Accounts/Finance Reports: Received Payments report",
            },
            print: true,
        },
    }, {
        name: `${prefix}.${pre}.received-payments-reports.print`,
        path: `/${prefix}/${pre}/received-payments-reports/print`,
        component: () => import('./prints/DeclaredReceivedPaymentsReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.received-payments-report.index`,
                PageDescription: "Accounts/Finance Reports: Received Payments report",
            },
            print: true,
        },
    },
    {
        name: `${prefix}.${pre}.deposit-details.print`,
        path: `/${prefix}/${pre}/deposit-details/print/:patientID/:ReceiptNo`,
        component: () => import('./prints/DepositDetails.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.received-payments-report.index`,
                PageDescription: "Accounts/Finance Reports: Received Payments report",
            },
            print: true,
        },
    },
    {
        name: `${prefix}.${pre}.received-payments-report.preview`,
        path: `/${prefix}/${pre}/received-payments-report/preview`,
        component: () => import('./prints/ReceivedPaymentReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.received-payments-report.index`,
                PageDescription: "Accounts/Finance Reports: Received Payments report",
            },
            print: true,
        },
    },
];